var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 25.7812C28.582 25.7812 33.5938 18.7695 33.5938 12.5C33.5938 6.03828 28.3367 0.78125 21.875 0.78125C15.4133 0.78125 10.1562 6.03828 10.1562 12.5C10.1562 18.7695 15.168 25.7812 21.875 25.7812Z",
    fill: "#E12828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2149 33.2148C29.554 36.8758 29.554 42.8125 33.2149 46.4734C36.8759 50.1343 42.8126 50.1343 46.4735 46.4734C50.1345 42.8125 50.1345 36.8758 46.4735 33.2148C42.8126 29.5539 36.8759 29.5539 33.2149 33.2148ZM43.1587 42.0531C43.4634 42.3578 43.4634 42.8531 43.1587 43.1578C42.854 43.4625 42.3587 43.4625 42.054 43.1578L39.8438 40.9484L37.6345 43.1578C37.3298 43.4625 36.8345 43.4625 36.5298 43.1578C36.2251 42.8531 36.2251 42.3578 36.5298 42.0531L38.7392 39.8437L36.5298 37.6344C36.2251 37.3297 36.2251 36.8343 36.5298 36.5297C36.8345 36.225 37.3298 36.225 37.6345 36.5297L39.8438 38.739L42.0532 36.5297C42.3579 36.225 42.8532 36.225 43.1579 36.5297C43.4626 36.8343 43.4626 37.3297 43.1579 37.6344L40.9485 39.8437L43.1587 42.0531Z",
    fill: "#E12828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7477 31.5297C29.7984 30.907 26.1914 30.4688 21.875 30.4688C13.1891 30.4688 7.36953 32.2414 4.01719 33.7289C2.05078 34.6 0.78125 36.5609 0.78125 38.7242V46.875C0.78125 47.3062 1.13125 47.6562 1.5625 47.6562H32.1961C30.168 45.6711 28.9063 42.9062 28.9063 39.8438C28.9063 36.5133 30.4 33.5359 32.7477 31.5297Z",
    fill: "#E12828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledUsers);
export default __webpack_public_path__ + "static/media/disabled-users.e9327d7a027dab94fea6503c277ee378.svg";
export { ForwardRef as ReactComponent };